<script setup>
    import { defineProps, defineEmits, defineExpose, ref, inject, computed } from 'vue';
    import { useReserveStore } from '@/stores/reserve/reserveStore';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    // メッセージダイアログ取得
    const { messageDialog } = inject('messageDialogKey');

    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();

    // ----------------------------
    // 定数
    // ----------------------------
    const reserveStore = useReserveStore();
    const message = computed(() =>
    props.message ? props.message : ''
    );

    // ----------------------------
    // Props
    // ----------------------------
    const props = defineProps({
        message: {
            type: String,
            default: '',
        },
        paymentRefundFlag: Boolean
    });

    // ----------------------------
    // Emits
    // ----------------------------
    const emit = defineEmits(['reserveCancelConfirmModal:confirm', 'reserveCancelConfirmModal:cancel', 'reserveCancelConfirmModal:error']);

    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    // 親画面から取得したAPIのドメイン部を管理する。
    const API_URL = ref('');
    const keepReservationPk = ref(null);

    // ----------------------------
    // 関数
    // ----------------------------
    /**
     * 予約取消API
     * @param queryParam
     */
    async function onConfirm() {
        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();
        // 予約取消APIをコールする。
        await getReserveConfirm();
    }

    function onCancel() {
        emit('reserveCancelConfirmModal:cancel');
    }
    // 「はい」押下時
    async function getReserveConfirm() {
        const requestBody = {
            ReservationPk: keepReservationPk.value,
        };
        // 予約取消API
        const response = await reserveStore.getReserveDeleteAction(API_URL.value, requestBody);

        if (response.success && (response.errorMessage == null || response.errorMessage == undefined)) {
            emit('reserveCancelConfirmModal:confirm');
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            emit('reserveCancelConfirmModal:error');
        }
    }

    /**
     * 親画面から問診票登録モーダルを開くイベントが実行された場合の処理。
     * @param {String} trg HTMLファイルタグが生成されている座標を取得する。
     * @returns なし
     */
     async function openModal(trg, reservationPk) {
        // APIのURL情報を取得する。
        API_URL.value = trg;

        // 親画面から取得した予約PKを保持する。
        keepReservationPk.value = reservationPk;
    }

    /**
     * 親画面から実行を許可する本コンポーネント内のメソッドの一覧。
     */
     defineExpose({
        openModal,
    });
</script>

<template>
    <article id="modalYoyakuCancel" class="modal small" :class="{ smallWide: props.paymentRefundFlag}" :style="{ display: 'block'}">
        <p class="textCenter" v-html="message"></p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="onCancel">{{ $t('reserveCancelConfirm.parts.modalButton1') }}</button>
                </li>
                <li>
                    <button type="button" class="btnPrimary" @click="onConfirm" :disabled="disabledStore.isDisabled">{{ $t('reserveCancelConfirm.parts.modalButton2') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>

<style>
</style>
